export default "__VITE_ASSET__Dq1CFtrc__"